import { tv } from 'tailwind-variants'

export const snackInformationVariants = tv({
  slots: {
    container: 'm-mili p-micro rounded-mili bg-primary-xlight flex items-center justify-between',
    iconAndRemainTime: 'flex flex-row items-center',
    icon: 'flex my-auto mx-deca text-centi text-primary-medium',
    remainTimeStyle: 'text-base text-primary-medium font-bold',
    button: 'my-auto border-none bg-primary-xlight'
  }
})
